import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../auth/UserPermissions';
import PermissionsModal from '../PermissionsModal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import * as paths from '../../util/paths';
import Button from '@amzn/awsui-components-react/polaris/button';


export default function ManualTestingHome() {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [hasAdminAccess] = React.useState(isFromTechTeam());

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <Box>
                    <Button
                        variant='primary'
                        href={paths.getRelativePath(paths.MANUAL_TESTING_USER_REQUESTS)}
                    >
                        View My Requests
                    </Button>
                </Box>
                {hasAdminAccess &&
                    <Box>
                        <Button
                            variant='normal'
                            href={paths.getRelativePath(paths.MANUAL_TESTING_ALL_REQUESTS)}
                        >
                            View All User Requests
                        </Button>
                    </Box>}
            </SpaceBetween>}
        </Box>
    );
}